import { render, staticRenderFns } from "./button-array-setting.vue?vue&type=template&id=1d83c014&scoped=true&"
import script from "./button-array-setting.vue?vue&type=script&lang=js&"
export * from "./button-array-setting.vue?vue&type=script&lang=js&"
import style0 from "./button-array-setting.vue?vue&type=style&index=0&id=1d83c014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83c014",
  null
  
)

export default component.exports